import React, { useState } from "react";
import { Form, FormGroup, Button } from "reactstrap";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import {
  buildRegistrationConsent,
  EMAIL_PLACEHOLDER,
  USER_ID_PLACEHOLDER,
} from "../utils/registrationValidationStrings";
import { getBrandStyle } from "../utils/brandColor";

// Per the Lovable design: an uppercase label sits above each field, with a red asterisk
// only on fields required in the current mode (Email/User ID are optional in either-mode).
const FieldLabel = ({ children, required }) => (
  <label className="bwai-reg-field-label">
    {children}
    {required && <span className="bwai-reg-required">*</span>}
  </label>
);

const RegistrationForm = ({
  phoneNumber,
  setPhoneNumber,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  onSubmit,
  companyName,
  logoUrl,
  brandColor,
  instruction,
  showEmail,
  showUserId,
  email,
  setEmail,
  userId,
  setUserId,
  formError,
  isLoading,
}) => {
  const isMobile = window.innerWidth < 768;
  const [logoFailed, setLogoFailed] = useState(false);
  const eitherMode = showEmail && showUserId;

  // The brand colour is the only dynamic style; an unusable value leaves the default look.
  const { brandClass, brandStyle } = getBrandStyle(brandColor);

  const inputStyle = {
    width: "100%",
    height: isMobile ? "60px" : "50px",
    fontSize: "16px",
  };

  return (
    <div className={brandClass} style={brandStyle}>
      {logoUrl && !logoFailed && (
        <img
          className="bwai-reg-logo"
          src={logoUrl}
          alt={companyName}
          onError={() => setLogoFailed(true)}
        />
      )}
      <h1
        className="mfa-title"
        style={{ fontSize: isMobile ? "24px" : "28px" }}
      >
        Enter your contact information
      </h1>
      <p
        className="mfa-subtitle"
        style={{ fontSize: isMobile ? "14px" : "16px" }}
      >
        Your company requires your contact information for employee
        registration.
      </p>
      {instruction && <p className="bwai-reg-instruction">{instruction}</p>}

      <Form onSubmit={onSubmit} noValidate>
        <FormGroup>
          <FieldLabel required>First Name</FieldLabel>
          <input
            type="text"
            className="form-control"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            style={{
              width: "100%",
              height: isMobile ? "60px" : "50px",
              fontSize: isMobile ? "16px" : "16px",
            }}
          />
        </FormGroup>
        <FormGroup>
          <FieldLabel required>Last Name</FieldLabel>
          <input
            type="text"
            className="form-control"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            style={{
              width: "100%",
              height: isMobile ? "60px" : "50px",
              fontSize: isMobile ? "16px" : "16px",
            }}
          />
        </FormGroup>
        {showEmail && (
          <FormGroup>
            <FieldLabel required={!eitherMode}>Email</FieldLabel>
            <input
              type="email"
              className="form-control"
              placeholder={EMAIL_PLACEHOLDER}
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={inputStyle}
            />
          </FormGroup>
        )}
        {showUserId && (
          <FormGroup>
            <FieldLabel required={!eitherMode}>User ID</FieldLabel>
            <input
              type="text"
              className="form-control"
              placeholder={USER_ID_PLACEHOLDER}
              autoComplete="off"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              style={inputStyle}
            />
          </FormGroup>
        )}
        <FormGroup>
          <FieldLabel required>Mobile Number</FieldLabel>
          <div className="phone-input-row bwai-reg-phone-row">
            <PhoneInputWithCountrySelect
              placeholder="Enter Mobile number"
              value={phoneNumber}
              onChange={setPhoneNumber}
              className="form-control p-0"
              defaultCountry="US"
              style={{
                width: "100%",
                height: isMobile ? "60px" : "50px",
                fontSize: isMobile ? "16px" : "16px",
              }}
            />
          </div>
          <p className="bwai-reg-consent">{buildRegistrationConsent(companyName)}</p>
        </FormGroup>

        {formError && (
          <p className="bwai-reg-error" role="alert">
            {formError}
          </p>
        )}

        <Button
          type="submit"
          color="dark"
          className="continue-btn"
          block
          disabled={isLoading}
          style={{ height: isMobile ? "45px" : "50px" }}
        >
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default RegistrationForm;
